import PageComponent from "components/Page";

import PriceLists from "pages/price/PriceLists";
import PriceView from "pages/price/Price";

import NewPriceDialog from "pages/price/components/NewPriceDialog";
import CreateSectionDialog from "pages/price/components/CreateSectionDialog";
import ChangePriceDialog from "pages/price/components/ChangePriceDialog";
import NewPositionDialog from "pages/price/components/NewPositionDialog";
import FileUploadDialog from "components/FileUploadDialog";

import './index.less';
import './themes/default.less';

const STATUS_EXPIRED = 0;
const STATUS_CURRENT = 1;
const STATUS_UPCOMING = 2;

export default class Price extends PageComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            mode: "prices",
            currentInfo: false,
            prices: { 0: { items: [] } },
            root: {}
        };
    }

    get dialogsMap() {
        return {
            "newPrice": NewPriceDialog,
            "createSection": CreateSectionDialog,
            "fileUpload": FileUploadDialog,
            "changePrice": ChangePriceDialog,
            "newPosition": NewPositionDialog,
        };
    }

    componentDidLoad() {
        const { mode } = this.state.urlProps;

        this.loadPrices(mode);
    }

    async onInPrice(info, modePrice) {
        this._helper.showLoading();

        const resp = await this._request.priceCategories.getPriceById(info.id);
        const data = resp?.data || [];

        this._helper.setPageProps({ id: info.id, mode: modePrice });

        if (data.length > 0) {

            this.state.currentInfo = info;

            const prices = { 0: data[0] };
            const mode = "price";

            this.setState({ mode, prices, root: data[0] });
        }

        this._helper.hideLoading();
    }

    toggleMode() {
        const { mode } = this.state;
        this.changeState("mode", mode === "price" ? "prices" : "price");
    }

    getValidity(status, dateFrom, dateTo) {
        if (status === STATUS_EXPIRED)
            return `${this._helper.date.toDateStr(dateFrom)} - ${this._helper.date.toDateStr(dateTo)}`;
        if (status === STATUS_CURRENT)
            return `${this._helper.date.toDateStr(dateFrom)} - ${this.tr("price.currentDay")}`;
        if (status === STATUS_UPCOMING)
            return `c ${this._helper.date.toDateStr(dateFrom)}`;
    }

    extractPrices(data) {
        const sortedData = data.sort((a, b) => new Date(b.dateFrom) - new Date(a.dateFrom));

        let lastExpiredIndex = null;
        for (let i = sortedData.length - 1; i >= 0; i--) {
            if (new Date(sortedData[i].dateFrom) < new Date())
                lastExpiredIndex = i;
            else
                break;
        }

        for (let i = 0; i < sortedData.length; i++) {
            if (i < lastExpiredIndex) {
                sortedData[i].status = STATUS_UPCOMING;
            } else if (i === lastExpiredIndex) {
                sortedData[i].status = STATUS_CURRENT;
            } else {
                sortedData[i].status = STATUS_EXPIRED;
            }
        }

        for (let i = 0; i < sortedData.length - 1; i++) {
            if (sortedData[i].status === STATUS_EXPIRED) {
                const nextDateFrom = new Date(sortedData[i - 1].dateFrom);
                const dateTo = new Date(nextDateFrom);
                dateTo.setDate(dateTo.getDate() - 1);
                sortedData[i].dateTo = this._helper.date.toStr(dateTo);
            }
        }

        return sortedData.map(it => {
            const { dateFrom, dateTo, createdBy } = it;
            const createdName = this._helper.getDoctorNameById(createdBy, "short");
            const validity = this.getValidity(it.status, dateFrom, dateTo);

            return { ...it, validity, createdName };
        });
    }

    findSelectedItem(listPrices) {
        const { id } = this._helper.getUrlOptions();

        if (!id)
            return false;

        if (id === "current")
            return listPrices.find(it => it.status === STATUS_CURRENT);

        return listPrices.find(it => it.id === +id);
    }

    async loadPrices(modeEdit) {
        this._helper.showLoading();

        const respPL = await this._request.priceLists.getPriceListsExtendet();
        const listPrices = this.extractPrices(respPL?.data || []);

        listPrices.sort((a, b) => b.status - a.status);

        const selectedItem = this.findSelectedItem(listPrices);
        if (selectedItem) {
            this.onInPrice(selectedItem, modeEdit ? "edit" : "view");
        }

        this.setState({ listPrices });
        this._helper.hideLoading();
    }

    downloadXlsx(prices, validity) {
        this._xlsx.price(prices, validity);
    }

    renderStatus(status) {
        if (status === 1) {
            return <div className="green">{this.tr("price.current")}</div>;
        } else if (status === 2) {
            return <div className="black">{this.tr("price.future")}</div>;
        }
        return <div className="gray">{this.tr("price.archival")}</div>;
    }

    renderPrice() {

        const { prices, root, currentInfo } = this.state;
        const renderStatus = this.renderStatus.bind(this);
        const onInPrice = this.onInPrice.bind(this);
        const openDialog = this.openDialog.bind(this);
        const loadPrices = this.loadPrices.bind(this);
        const downloadXlsx = this.downloadXlsx.bind(this);

        const toggleMode = this.toggleMode.bind(this);

        const props = { prices, renderStatus, onInPrice, openDialog, loadPrices, toggleMode, root, currentInfo, downloadXlsx };

        return (<PriceView {...props} />);
    }

    renderPrices() {
        const { listPrices } = this.state;
        const renderStatus = this.renderStatus.bind(this);
        const onInPrice = this.onInPrice.bind(this);
        const openDialog = this.openDialog.bind(this);
        const loadPrices = this.loadPrices.bind(this);
        const downloadXlsx = this.downloadXlsx.bind(this);

        const props = { listPrices, renderStatus, onInPrice, openDialog, loadPrices, downloadXlsx };

        return (<PriceLists {...props} />);
    }

    renderPage() {
        const { mode } = this.state;
        return (mode === "prices" ? this.renderPrices() : this.renderPrice());
    }
}
